<script lang="ts">
  import { onMount } from "svelte"
  import * as Carousel from "$lib/components/ui/carousel"
  import { createEventDispatcher } from "svelte"

  let { competition, layout } = $props()

  let carouselVisible = $state(true)
  let currentIndex = $state(0)
  let emblaApi: any = null
  const dispatch = createEventDispatcher()

  // Function to navigate to a specific slide
  function goToSlide(index: number) {
    console.log("Attempting to go to slide:", index, "API:", emblaApi)

    if (emblaApi) {
      emblaApi.scrollTo(index)
      currentIndex = index
    } else {
      console.error("Carousel API not available")
      // Try to dispatch an event to the carousel
      dispatch("scrollTo", { index })
    }
  }

  // Function to handle API initialization
  function onInit(api: any) {
    console.log("Embla initialized with API:", api)
    emblaApi = api

    // Set up listener for slide changes
    emblaApi.on("select", () => {
      currentIndex = emblaApi.selectedScrollSnap()
    })
  }

  onMount(async () => {
    // Check if any competition media exist and are valid
    const mediaItems = competition.media && competition.media.length > 0 ? competition.media : (competition.images && competition.images.length > 0 ? competition.images.map((url: string) => ({ type: 'image', url })) : [])
    
    if (mediaItems.length > 0) {
      const checkMedia = (media: any) => {
        return new Promise((resolve) => {
          if (media.type === 'youtube') {
            // For YouTube videos, assume they're valid
            resolve(true)
            return
          }
          
          const url = media.url || media
          if (media.type === 'video' || (!media.type && url.match(/\.(mp4|webm|ogg|mov|avi)$/i))) {
            // For videos, try to create a video element to check
            const video = document.createElement('video')
            video.onloadedmetadata = () => resolve(true)
            video.onerror = () => resolve(false)
            video.src = url
          } else {
            // For images
            const img = new Image()
            img.onload = () => resolve(true)
            img.onerror = () => resolve(false)
            img.src = url.replace(
              "https://img.promoamp.com/",
              "https://img.promoamp.com/cdn-cgi/image/width=1000/",
            )
          }
        })
      }

      // Check all media
      const results = await Promise.all(mediaItems.map(checkMedia))
      if (results.every((result) => !result)) {
        carouselVisible = false
      }
    }
  })
</script>

{#if carouselVisible}
  {#if competition.is_demo_for}
    <div class="relative w-full h-[300px] overflow-hidden sm:rounded-t-[10px]">
      {#if competition.images && competition.images.length > 0}
        <div
          class="absolute inset-0"
          style="background-image: url('{competition
            .images[0]}'); background-size: cover; background-position: center; background-repeat: no-repeat;"
        ></div>
      {/if}
      <div
        class="absolute inset-0"
        style={competition.widgetCustomizations?.colorSettings
          ?.primaryBackgroundColor
          ? `background-color: ${competition.widgetCustomizations?.colorSettings?.primaryBackgroundColor}; opacity: 0.6;`
          : "background-color: #000000; opacity: 0.6;"}
      ></div>
      <div
        class="absolute inset-0 flex flex-col items-center justify-center gap-2"
      >
        <span class="giveaway-text outlined">GIVEAWAY</span>
        <span class="giveaway-text solid">GIVEAWAY</span>
        <span class="giveaway-text outlined">GIVEAWAY</span>
        <span class="giveaway-text solid">GIVEAWAY</span>
        <span class="giveaway-text outlined">GIVEAWAY</span>
      </div>
    </div>
  {:else}
    {@const mediaItems = competition.media && competition.media.length > 0 ? competition.media : (competition.images && competition.images.length > 0 ? competition.images.map((url: string) => ({ type: 'image', url })) : [])}
    {#if mediaItems.length > 0}
              <Carousel.Root
          opts={{ loop: true }}
          on:init={({ detail }) => onInit(detail)}
      >
        <Carousel.Content>
          {#each mediaItems as media}
            <Carousel.Item>
              {#if media.type === 'image' || !media.type}
                <img
                  src={(media.url || media).replace(
                    "https://img.promoamp.com/",
                    "https://img.promoamp.com/cdn-cgi/image/width=1000/",
                  )}
                  alt="Competition promotional content"
                  class="w-full object-cover"
                  class:sm:rounded-t-[6px]={layout !== "landscape"}
                  class:max-h-[300px]={layout !== "landscape"}
                  class:sm:rounded-tl-[6px]={layout === "landscape"}
                  class:sm:rounded-tr-[0px]={layout === "landscape"}
                />
              {:else if media.type === 'video'}
                <video
                  src={media.url}
                  class="w-full object-cover"
                  class:sm:rounded-t-[6px]={layout !== "landscape"}
                  class:max-h-[300px]={layout !== "landscape"}
                  class:sm:rounded-tl-[6px]={layout === "landscape"}
                  class:sm:rounded-tr-[0px]={layout === "landscape"}
                  autoplay
                  muted
                  loop
                  playsinline
                  controls
                >
                  <track kind="captions" />
                </video>
              {:else if media.type === 'youtube'}
                <div class="relative w-full aspect-video max-h-[300px]">
                  <iframe
                    src={media.url}
                    class="w-full h-full object-cover"
                    class:sm:rounded-t-[6px]={layout !== "landscape"}
                    class:sm:rounded-tl-[6px]={layout === "landscape"}
                    class:sm:rounded-tr-[0px]={layout === "landscape"}
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    title="YouTube video"
                  ></iframe>
                </div>
              {/if}
            </Carousel.Item>
          {/each}
        </Carousel.Content>
        {#if mediaItems.length > 1}
          <div
            class="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 px-3 py-1.5 rounded-full bg-black/20 backdrop-blur-sm"
          >
            {#each mediaItems as _, i}
              <Carousel.Dot index={i} />
            {/each}
          </div>
        {/if}
      </Carousel.Root>
    {/if}
  {/if}
{/if}

<style>
  .giveaway-text {
    font-size: 2.8rem;
    font-weight: 900;
    letter-spacing: 0.1em;
    line-height: 1;
  }

  .giveaway-text.outlined {
    color: transparent;
    -webkit-text-stroke: 2px white;
  }

  .giveaway-text.solid {
    color: white;
  }
</style>
